import { useEffect, useState } from 'react';
import { OfferStepper } from '../components/elements/offerStepper';
import { InfoDrawer } from '../components/offer/InfoDrawer';
import { Documentation } from '../components/offer/documentation/Documentation';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Signature } from '../components/offer/signature/Signature';
import { useQuery } from '@tanstack/react-query';
import { getOrderByIdFn } from '../transactions/orders/orders';
import { useAcceptOffer, usePostPreferenceFormFn } from '../hooks/react-query/useOffer';
import { ContractSection } from '../components/offer/signature/ContractSection';
import { useAddStandingOrdersFn } from '../hooks/react-query/useOrder';
import { useToast } from '../components/ui/Toast/useToast';
import { SuccessOfferPage } from './successPage';
import { DocumentOptions } from '../components/offer/kyc/DocumentOptions';
import { VeryficationOptions } from '../components/offer/kyc/VerificationOptions';
import usePersonStore from '../store/personStore';
import { mapStepToMessage } from '../utils/helper';
import { Button } from '../components/ui/Button';
import { downloadOffer } from '../transactions/offer/offer';

export const FinalizeOffer = () => {
  const [currentStep, setCurrentStep] = useState();
  const [currentSubStep, setCurrentSubStep] = useState();
  const [polling, setPolling] = useState({ polling: false })
  const [continueSalesperson, setContinueSalesperson] = useState(false)
  const [documentUserSelection, setDocumentUserSelection] = useState(false);


  const { mutate: postPreferences } = usePostPreferenceFormFn();
  const { mutate: standingOrder } = useAddStandingOrdersFn();
  const { mutate: acceptOffer } = useAcceptOffer();

  const { toast } = useToast();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const { orderId } = useParams();

  const showRetailDashboard = usePersonStore(
    (store) => store.showRetailDashboard
  );

  const { data } = useQuery({
    queryKey: [orderId, currentStep, currentSubStep],
    queryFn: () => getOrderByIdFn(orderId),
    onSuccess: (data) => {
      if (data.exceptions.length > 0) {
        navigate(showRetailDashboard ? '/dashboard': '/portal/my-cars')
      } else {
        if (parseInt(data.data.cncode) !== parseInt(orderId)) {
          navigate(`/track-your-car/details/${data.data.cncode}`);
        }
        setCurrentStep(data.data.state.step);
        setCurrentSubStep(data.data.state.substatus)
        setPolling({ polling: data.data.state.polling, pollingInterval: data.data.state.pollingInterval})
      }
    },
    // staleTime: Infinity,
    cacheTime: Infinity,
    enabled: orderId !== undefined,
    refetchInterval: polling.polling ? polling.pollingInterval : false,
  });

  useEffect(() => {
    if (data && data.data.state) {
      setCurrentStep(data.data.state.step);
      setCurrentSubStep(data.data.state.substatus);
      setPolling({
        polling: data.data.state.polling,
        pollingInterval: data.data.state.pollingInterval,
      });
    }
  }, [data]);

  useEffect(() => {
    let paymentHappened = searchParams.get('paymentStatus');
    if (searchParams && paymentHappened) {
      navigate(`/track-your-car/details/${orderId}`);
    }
  }, [searchParams, orderId]);

  const handlePayment = (data) => {
    let formData = new FormData();
    let jsonData = '';

    if (data.enableInstallments) {
      jsonData = data.document.fileArray[0];

      formData.set('standingOrderMimeType', jsonData['type'].split('/')[1]);
      formData.set('standingOrder', data.document.fileArray[0]);
      formData.set('bankList', data.bank);
      formData.set('iban', data.iban);
      formData.set('selection', 'standingOrder');
    } else {
      formData.set('selection', 'skip');
    }

    standingOrder(
      { cncode: orderId, data: formData },
      {
        onSuccess: (data) => {
          if (data.data.status === 'success') {
            setCurrentSubStep(3);
          } else {
            toast({
              title: 'Απέτυχε',
              description:
                'Ανεπιτυχής ταυτοποίηση χρήστη, προσπάθησε ξανά.',
              variant: 'destructive',
            });
          }
        },
      }
    );
  };

  const handleAccept = () => {
    acceptOffer(orderId, {
      onSuccess: () => {
        setCurrentStep(2)
      }
    })
  }

  return (
    <>
      {data && currentStep > 6 ? (
        <SuccessOfferPage data={data.data} />
      ) : (data &&
        <div className="flex flex-col h-fit min-h-[100%] max-lg:bg-white lg:bg-[#F5F5F7] relative">
          <OfferStepper
            currentStep={currentStep}
              currentSubStep={currentSubStep}
              kyc={data.data.kyc}
          />
          <div
            className="flex-1 relative overflow-auto"
            style={{
              flex: '1 1 auto',
            }}
          >
            {data && Object.keys(data.data).length !== 0 && <InfoDrawer data={data.data} />}
            {data && currentStep < 1 &&
              <div className='lg:left-[400px] pt-10 absolute top-0 w-full lg:w-[calc(100vw-500px)] max-lg:p-2 max-lg:pb-20'>
                <div className="w-full flex p-8 flex-col gap-4 border border-[#A5A5A5] rounded-[12px] max-lg:bg-[#F5F5F7]">
                  <h4>Τελευταία Ενημέρωση</h4>
                  <p className="text-body">{mapStepToMessage(data.data.state.step,'') ?? data.data.state.message}</p>
                </div>
              </div>
              }
                {data && currentStep === 1 &&
                  <div className='lg:left-[400px] pt-10 absolute top-0 w-full flex flex-col gap-16 items-center lg:w-[calc(100vw-500px)] max-lg:p-2 max-lg:pb-20'>
                  <h3>Η προσφορά σου είναι έτοιμη!</h3>
                  <p className='text-body'>Μπορείς να δεις αναλυτικά τη διαμόρφωση του αυτοκινήτου και τα στοιχεία της προσφοράς σου στον πίνακα ή κάνοντας λήψη του PDF. Επίλεξε «Αποδοχή» για να ολοκληρώσεις το leasing σου.</p>
                  <div className='flex flex-col gap-4'>
                    <Button className='text-white bg-[#D4002A] py-3 px-10 rounded-[6px] w-fit text-primary-button' onClick={handleAccept}>Αποδοχή</Button>
                    <Button className={'border border-[#A5A5A5] py-3 px-10 rounded-[6px] text-primary-button'} onClick={()=>{downloadOffer(data.data.documents[data.data.documents.length-1].link)}}><span className='font-[700]'>Λήψη</span> PDF</Button>
                  </div>
                  </div>
            }
            {data && data.data.state && data.data.state.step === 2 && ((data.data.kycEligible && !documentUserSelection ) || (data.data.salesPersonFlow && !continueSalesperson && !data.data.kyc))?
              <DocumentOptions salesPersonFlow={data.data.salesPersonFlow} continueSalesperson={continueSalesperson} setContinueSalesperson={setContinueSalesperson} setUserSelection={setDocumentUserSelection} cncode={orderId} normalFlowText={'Complete New Client Form'} /> :
            
            data && (currentStep === 2 || currentStep === 3 || currentStep === 4 || (currentStep === 5 && (currentSubStep === 0 || currentSubStep === ''))) && (
              <Documentation
                setCurrentStep={setCurrentStep}
                currentStep={currentStep}
                newCustomerForm={data.data.newCustomerForm}
                state={data.data.state}
                isKYC={data.data.kyc}
                customerCode={data.data.customerType.code}
                onDocumentationComplete={(preferenceInfo) => {
                  postPreferences({ cncode: orderId, data: preferenceInfo },
                    {
                      onSuccess: (data) => {
                        if (data && data.data.status !== 'fail') {
                          setCurrentSubStep(1);
                        }
                      }
                    })
                }}
              />
            )}
            {data && currentStep === 5 && currentSubStep !== 0 && currentSubStep !== '' && (
              <>
              {(data.data.validateSigneeOptions.length === 1 ||currentSubStep !== 1 ) ?
                <ContractSection
                  onStepCompleted={() => {
                    setCurrentStep(5);
                    }}
                    cncode={orderId}
                  validateSigneeOptions={data.data.validateSigneeOptions[0]}
                  currentSubStep={currentSubStep}
                  documents={data.data.documents}
                /> :
                <VeryficationOptions cncode={orderId}/>    
              }
              </>
            )}
            {data && currentStep === 6 &&
              <Signature
                data={data.data}
                currentSubStep={currentSubStep}
                setCurrentStep={setCurrentSubStep}
                onCompletion={handlePayment}
              />
            }
          </div>
        </div>
      )}
    </>
  );
};
